export enum TaskResultMessageSeverity {
Info,
Warning,
Error,
}
